<template>
    <div class="form-group">
        <template v-if="readOnly">
            <p class="form-control-static">{{ outOfPocketLabel }}</p>
        </template>
        <template v-else>
            <template v-for="opt in options">
                <input name="oop" type="radio" :value="opt.value" v-model="outOfPocketOption" :id="'oop-' + opt.value">
                <label :for="'oop-' + opt.value">{{ opt.label }}</label><br>
            </template>
        </template>
    </div>
</template>

<script>
    const OPTIONS = [
        { value: 1, label: 'Credit/Debit Card Only' },
        { value: 2, label: 'Payroll Deductions Only' },
        { value: 3, label: 'Option to select either Credit/Debit Card or Payroll Deduction' }
    ];

    export default {
        name: "OutOfPocketPaymentOptions",
        props: {
            value: { required: true, validator: prop => prop === null || Number.isInteger(prop) },
            readOnly: { type: Boolean, default: false }
        },
        data() {
            return {
                outOfPocketOption: this.value,
                options: OPTIONS
            };
        },
        computed: {
            outOfPocketLabel() {
                const option = OPTIONS.find(o => o.value === this.outOfPocketOption);
                return option ? option.label : '';
            }
        },
        watch: {
            value: {
                handler(newVal) {
                    this.outOfPocketOption = newVal;
                }
            },
            outOfPocketOption() {
                if (!this.readOnly) {
                    this.$emit('input', this.outOfPocketOption);
                }
            }
        }
    };
</script>

<style scoped>

</style>